module.exports = __webpack_public_path__ + "static/img/carousel_2_klrq02_ar_16_9_w_1335.b6ca2a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_2_klrq02_ar_16_9_w_1335.jpg
// module id = qT/i
// module chunks = 0